import { deleteToken } from '@gonfalon/openapi/operations/deleteToken';
import { getToken } from '@gonfalon/openapi/operations/getToken';
import { getTokens } from '@gonfalon/openapi/operations/getTokens';
import { patchToken } from '@gonfalon/openapi/operations/patchToken';
import { postToken } from '@gonfalon/openapi/operations/postToken';
import { resetToken } from '@gonfalon/openapi/operations/resetToken';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { createQueryOptions } from '../internal/createQueryOptions';

export const getTokensQuery = createQueryOptions(getTokens);
export const getTokenQuery = createQueryOptions(getToken);

export const useCreateToken = createMutationHook(postToken, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: getTokensQuery.partialQueryKey() });
  },
});

export const useDeleteToken = createMutationHook(deleteToken, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: getTokensQuery.partialQueryKey() });
  },
});

export const usePatchToken = createMutationHook(patchToken, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: getTokensQuery.partialQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getTokenQuery.partialQueryKey() }),
    ]);
  },
});

// `resetToken` is a bodyless POST, so openapi-fetch omits the Content-Type
// header — but the backend rejects POSTs without `application/json`. Set it
// explicitly so the call reaches the handler.
export const useResetToken = createMutationHook(
  (input: Parameters<typeof resetToken>[0]) => resetToken(input, { headers: { 'Content-Type': 'application/json' } }),
  {
    onSuccess: async () => {
      const queryClient = getQueryClient();
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: getTokensQuery.partialQueryKey() }),
        queryClient.invalidateQueries({ queryKey: getTokenQuery.partialQueryKey() }),
      ]);
    },
  },
);
